var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('FooterMain'),_vm._v(" "),_c('FooterBottom'),_vm._v(" "),_c('region-select')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }